export default "__VITE_ASSET__Bsejs7w2__"